/**
 * Location Radio Field
 *
 * @author Dan Pomeroy (dp@yext.com)
 */
goog.provide('yext.location.radio');

/**
 * Radio class
 * @constructor
 */
var Radio = function($element) {
  this.$element = $element;
  this.initializeDataModelFromDOM();
  this.bindUpdated();
  this.bindResetAll();
};

var radioSelector = '.js-radio';

/**
 * @param $element the element representing this radio
 */
yext.location.radio.create = function($element) {
  return new Radio($element);
};

/**
 * Parses the current DOM state of this element into
 * the data model for the Radio.
 */
Radio.prototype.initializeDataModelFromDOM = function() {
  var self = this;
  this.selectedValues = {};
  this.$element.find(radioSelector).each(function() {
    var $this = $(this);
    if ($this.attr('checked')) {
      self.selected = $this.val();
    }
    self.selectedValues[$this.val()] = $this.siblings('.js-value-text').text();
  });

  this.indeterminate = this.$element.find('.js-indeterminate').is(':visible');
};

/**
 * Binds the updated trigger when a radio is clicked.
 */
Radio.prototype.bindUpdated = function() {
  var $element = this.$element;
  $element.find(radioSelector).change(function() {
    $(this).trigger('updated');
    $element.find('button[type=submit]').prop('disabled', false);
  });

  var self = this;
  $(this).on('dataModel.updated', function() {
    var $valueDisplay = self.$element.find('.js-value-display');
    if (!self.indeterminate) {
      $valueDisplay.text(self.selectedValues[self.selected]);
    }
    $valueDisplay.toggle(!self.indeterminate);
    self.$element.find('.js-indeterminate').toggle(self.indeterminate);
    self.reset();
  });
};

/**
 * Binds the reset button for the indeterminate edit case.
 */
Radio.prototype.bindResetAll = function() {
  var self = this;
  this.$element.find('.js-indeterminate-reset').click(function() {
    self.$element.find('.js-indeterminate-edit').hide();
    self.$element.find('.js-radio-buttons').show();
  });
};

/**
 * Resets the selected radio buttons, usually when cancel
 * is clicked.
 */
Radio.prototype.reset = function() {
  if (!this.indeterminate) {
    this.$element.find(radioSelector).filter(valueSelector(this.selected)).prop('checked', 'checked');
  } else {
    this.$element.find(radioSelector).prop('checked', false);
  }

  this.$element.find('.js-indeterminate-edit').toggle(this.indeterminate);
  this.$element.find('.js-radio-buttons').toggle(!this.indeterminate);

  this.$element.find('.submit').attr('disabled', 'disabled');
};

/**
 * @param data Updates the radios model based on the provided data
 */
Radio.prototype.updateDataModel = function(data) {
  if (data.errors) {
    this.errors = data.errors;
    return;
  }
  this.indeterminate = data.indeterminate;
  if (this.indeterminate) {
    this.selected = undefined;
  } else {
    this.selected = data.selected;
  }

  $(this).trigger('dataModel.updated');
};

var valueSelector = function(value) {
  return '[value="' + value + '"]';
};
